import type { GuidelineRepresentation } from '../types';

/**
 * Helper to select the appropriate guideline based on guidelineRepresentation.
 * When in EDITOR mode, prefers guidelineADF but falls back to guideline if ADF is empty.
 * When in PLAIN mode, uses the plain text guideline.
 *
 * @param {object} params - Parameters object
 * @param {string | undefined} params.guidelineADF - ADF format guideline (JSON string)
 * @param {string | undefined} params.guideline - Plain text guideline
 * @param {GuidelineRepresentation} params.guidelineRepresentation - Format type (PLAIN or EDITOR)
 * @returns {string | undefined} The selected guideline to use
 */
export const selectGuideline = ({
	guidelineADF,
	guideline,
	guidelineRepresentation,
}: {
	guideline?: string;
	guidelineADF?: string;
	guidelineRepresentation?: GuidelineRepresentation;
}): string | undefined => {
	if (guidelineRepresentation === 'EDITOR') {
		// Prefer ADF format when in EDITOR mode, fallback to plain text
		// Use nullish coalescing to treat empty strings as valid values
		return guidelineADF ?? guideline;
	}

	// Use plain text guideline for PLAIN mode
	return guideline;
};
